var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"components-cascader-demo"}},[_c('d-cascader',{attrs:{"placeholder":"请选择","load-data":_vm.loadOptions,"options":_vm.options},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }